<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Liquidaciones Facturadas</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <button class="btn base-button btn-neutral btn-sm mt-1" title="Descargar" @click="mixDownloadPdf">
            <i class="fas fa-download mr-1"></i>Descargar PDF
          </button>
          <router-link
            v-if="$can('index', 'orders')"
            :to="{ name: 'LiquidationDetail' }"
            class="btn base-button btn-neutral btn-sm mt-1"
          >
            Ver Detalle
          </router-link>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-sm-12">
          <card>
            <liquidation-table v-bind="mixLiquidationFilters">
              <template #filters>
                <liquidation-filters
                  :is-by-seller="false"
                  @distributorSelect="distributorSelect"
                  @sellerSelect="sellerSelect"
                  @campaignSelect="campaignSelect"
                  @rangeDates="datesSelect"
                  @search="search"
                />
              </template>
            </liquidation-table>

            <liquidation-by-months v-bind="mixLiquidationFilters" />
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import LiquidationFilters from '@/views/Receipts/Forms/LiquidationFilters.vue';

import LiquidationTable from './List/LiquidationTable.vue';
import LiquidationByMonths from './List/LiquidationByMonths.vue';
import LiquidationFilterMixin from './Mixins/LiquidationFilterMixin';

export default {
  name: 'ReceiptsLiquidationDistributor',
  components: {
    RouteBreadCrumb,
    LiquidationTable,
    LiquidationByMonths,
    LiquidationFilters,
  },

  mixins: [LiquidationFilterMixin],
};
</script>
